import * as ActionType from '../actions/report';

const defaultState = {
	shouldRedirect: false,
	url: null
};

/**
 * @description
 * get the report data
 *
 * @param {Object} state
 * @param {Object} action
 * @returns {*}
 */
export default function report (state = defaultState, action) {
	let newState = { ...state };

	switch (action.type) {

		case ActionType.REPORT_REQUEST_GET: {
			return state;
		}

		case ActionType.REPORT_SUCCESS_GET: {
			newState.url = action.payload.finishQuestionnaireUrl;
			newState.shouldRedirect = true;
			return newState;
		}

		case ActionType.REPORT_FAILURE_GET: {
			return state;
		}

		default:
			return state;
	}
}
